import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const user = useSelector(state => state.session.user)
  const location = useLocation();
  return user ? children : <Navigate to='/login' replace state={{ from: location }} />;
};


export default ProtectedRoute;
